<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
        <div v-if="(selectedDepts || []).length">
          <p class="font-34 p-16-0 p-0-16">部门</p>
          <div
            v-for="item in selectedDepts"
            :key="item.deptTpId"
            class="bg-FFFFFF pl-16"
          >
            <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
              <div
                class="item-flex-1 height-full fb fb-main-between fb-cross-center hidden-x"
              >
                <div class="item-flex-1 font-34 fb fb-cross-center hidden-x">
                  <div class="pr-5 w-adapt-48 text-ellipsis">{{
                    item.deptName
                  }}</div>
                  <div class="c-111F2C-40">({{ item.studentCnt }})</div>
                </div>
                <i
                  class="iconfont font-40 c-171A1D-40 mr-16"
                  @click="clearDept(item)"
                  >&#xe670;</i
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="(selectedMembers || []).length">
          <p class="font-34 p-16-0 p-0-16">人员</p>
          <div
            v-for="item in selectedMembers"
            :key="item.memberDingId"
            class="bg-FFFFFF pl-16"
          >
            <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
              <div class="head-img-text fb fb-main-center fb-cross-center">
                {{ nameLastTwoWords(item.userName) }}
              </div>
              <div
                class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              >
                <div class="item-flex-1">
                  <div class="fb fb-col fb-main-center p-9-0">
                    <div class="fb fb-main-start fb-cross-center mb-4">
                      <span class="font-34 pr-5 max-w-100 text-ellipsis">{{
                        item.userName
                      }}</span>
                      <span
                        class="iconfont font-32"
                        :style="{
                          color: +item.gender === 1 ? '#006AFE' : '#ff4d94'
                        }"
                        v-show="item.gender"
                        v-html="SEX_TYPE_ICON[+item.gender]"
                      ></span>
                    </div>
                  </div>
                </div>
                <i
                  class="iconfont font-40 c-171A1D-40 mr-16"
                  @click="clearMember(item)"
                  >&#xe670;</i
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="confirmDetail"
          >确定</common-button
        >
      </div>
    </div>

    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        :searchValue="searchKey"
        class="p-8-0 p-0-8 bg-FFFFFF"
        placeholder="搜索"
        :delay="1000"
        @search="handlerToSearchMembers"
      ></common-search-input-box>

      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="nodeNav.length > 0 && !searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="multiple && computedIsShowSelectAll"
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox
          :class="{ 'c-171A1D-28': computedIsDisabledSelectAll }"
          :isChecked="!computedIsDisabledSelectAll && compuedIsSelectedAll"
          @click="handlerToChangeSelections"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div>
      <div class="item-flex-1 scroll">
        <!-- 搜索结果成员列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchMembers.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center pl-16 bg-FFFFFF"
            @click="handlerChangeMemberSelections(member)"
            v-for="(member, index) in searchMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  member.selected ||
                  singleNodeSelected.userTpId === member.userTpId
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  member.selected ||
                  singleNodeSelected.userTpId === member.userTpId
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-24">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.userName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.userName }}</span
                  >
                  <span
                    class="font-28 iconfont"
                    v-show="member.gender"
                    :style="{
                      color: member.gender === 1 ? '#006AFE' : '#FF4D94'
                    }"
                    >{{ member.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="
            !searchKey &&
            ((currentDepts || []).length || (currentMembers || []).length > 0)
          "
          class="node-list item-flex-1 bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in currentDepts"
            class="fb-start-center h-56 lh-56 pl-16"
            :key="node.deptId"
          >
            <span
              v-if="multiple"
              class="mr-16"
              :class="[
                'iconfont font-48',
                node.selected ? 'c-006AFE' : 'c-171A1D-24'
              ]"
              @click="handlerChangeDeptSelected(node)"
            >
              {{ node.selected ? '&#xe66e;' : '&#xe66f;' }}
            </span>
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16 hidden-x"
            >
              <div
                class="item-flex-1 fb fb-cross-center hidden-x"
                @click="handlerChangeDeptSelected(node)"
                ><div
                  :class="[
                    'text-ellipsis inline-block pr-4 w-adapt-48',
                    'c-171A1D'
                  ]"
                  >{{ node.deptName }}</div
                >
                <div class="c-111F2C-40">({{ node.studentCnt }})</div>
              </div>
              <div class="c-006AFE font-34">
                <span
                  class="bl-12 pl-9"
                  v-if="node.hasChildren || node.type === 5"
                  @click.stop="handlerToGetSubNodes(node)"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
          <!-- 部门成员列表 -->
          <div
            class="fb fb-row fb-cross-center pl-16"
            @click="handlerChangeMemberSelections(member)"
            v-for="(member, index) in currentMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  member.selected ||
                  singleNodeSelected.userTpId === member.userTpId
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  member.selected ||
                  singleNodeSelected.userTpId === member.userTpId
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div
              class="bb item-flex-1 fb fb-row fb-cross-center p-12-0 hidden-x"
            >
              <div class="mr-12 font-32">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.userName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.userName }}</span
                  >
                  <span
                    class="font-28 iconfont"
                    v-show="member.gender"
                    :style="{
                      color: member.gender === 1 ? '#006AFE' : '#FF4D94'
                    }"
                    >{{ member.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
      >
        <div
          class="item-flex-1 c-006AFE text-ellipsis"
          @click.stop="handlerViewDetail"
        >
          {{ computedSelectedText }}
          <i v-show="computedShowDetail" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button
            type="primary"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import API from '@/api/addressbook'
import store from '@/store'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonHeadImg,
  commonButton,
  commonCheckbox
} from '@/components/commonAddressBook'
import {
  getItem,
  nameLastTwoWords,
  setLeft,
  removeLeft,
  pushNullUrl,
  deepCopy,
  getTitle
} from '@/utils/comUtils'
import {
  mcConfirm,
  mcShowPreloader,
  mcHidePreloader,
  mcToast,
  mcSetTitle
} from '@/utils/mcSdkUtils'

import { SEX_TYPE_ICON } from '@/utils/constUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonHeadImg,
    commonButton,
    commonCheckbox
  },
  props: {},
  data() {
    return {
      SEX_TYPE_ICON,
      nameLastTwoWords,
      // =================================================================
      rootDeptId: '',
      // sandboxId: '', getLocalItem('orgSandboxId') || getItem('orgSandboxId') || '', // 机构沙盒id

      singleNodeSelected: {},
      selectedMembers: [], // 已选人员列表
      selectedDepts: [], // 已选部门列表
      memberCount: 0,
      // =================================================================
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentMembers: [], // 当前展示成员节点列表
      // 成员搜索相关
      isFocus: false, // 搜索框是否聚焦
      searchKey: '', // 搜索人员姓名关键字
      searchMembers: [], // 当前搜索人员姓名列表
      showSelectDetail: false, // 展示选择详情
      sandboxStatus: 1, // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 已坏掉（处理数据异常） 8 已关闭
      sandboxItvl: null, // 查询状态定时器
      parentTpId: '', // 父节点id
      parentDeptId: '', // 父节点id
      pageNum: 50, // 分页页码
      pageSize: 9999, // 查询部门下面的人
      clicking: false,
      clearConfirm: null
    }
  },
  computed: {
    postData() {
      return {
        campusId:
          getItem('currentCapmusId') ||
          (store.getters.currentCapmus || {}).tpId ||
          '',
        currentRole: '3',
        sandboxType: this.sandboxType
      }
    },
    computedCanSelectMember() {
      return [0, 2, 4, 6].includes(+this.returnType)
    },
    computedCanSelectDept() {
      return [1, 3, 5, 6].includes(+this.returnType)
    },
    computedShowDetail() {
      return (
        this.computedSelectedText && (this.multiple || +this.returnType === 6)
      )
    },
    computedSelectedText() {
      // 0: 人员 1: 部门 2: 人员tpId 3: 部门tpId 4: 人员memberId 5: 部门memberId 6: 全选
      let _result = ''
      const { memberCount } = this
      if (memberCount === 1) {
        _result = `已选择: ${(this.selectedMembers[0] || {}).userName || ''}`
      } else if (memberCount > 1) {
        _result = `已选择: ${memberCount || ''}人`
      }
      // 单选走单独的逻辑
      if (!this.multiple && (this.singleNodeSelected || {}).userName) {
        _result = `已选择: ${(this.singleNodeSelected || {}).userName || ''}`
      }
      return _result
    },
    // 计算是否展示全选
    computedIsShowSelectAll() {
      let _result = true
      // 显示搜索人员姓名 || 无部门无成员 || 选择成员时无可选成员 || 选择部门时无可选部门
      if (
        this.searchKey ||
        (!(this.currentMembers || []).length &&
          !(this.currentDepts || []).length)
      ) {
        _result = false
      }
      return _result
    },
    // 计算禁用全选
    computedIsDisabledSelectAll() {
      let _result = false
      if ((this.currentDepts || []).length) {
        let _tag = true
        this.currentDepts.forEach(item => {
          if (item.memberCnt) {
            _tag = false
          }
        })
        _tag && (_result = true)
      }
      return false && _result
    },
    // 计算全选是否勾选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      deepCopy(this.currentDepts)
        .concat(deepCopy(this.currentMembers))
        .forEach(item => {
          if (!item.selected) {
            _isSelectAll = false
          }
        })
      return _isSelectAll
    }
  },
  watch: {},
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    // 钉钉回退按钮监听拦截
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearInterval(this.sandboxItvl)
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init() {
      if (!this.sandboxId) {
        await this.addressCreate()
      }
      await this.getSandboxStatus()
      await this.addressGetNodes(true)
      if (this.selectedMemberIds.length) {
        await this.addressBatchSelectMember(this.selectedMemberIds, true)
      }
      this.methodInitNodeNav()
    },
    // 初始化数据
    initData() {
      this.parentTpId = '' // 父节点id
      this.parentDeptId = '' // 父节点id
      this.searchKey = ''
      this.searchMembers = []
    },
    // 搜索人员姓名
    async handlerToSearchMembers(searchKey) {
      this.searchKey = searchKey
      if (!searchKey) {
        this.addressGetNodes()
        return
      }
      this.fetchMembersByKey()
    },
    // 获取子部门/人员
    async handlerToGetSubNodes(node) {
      if (this.clicking) {
        return
      }
      this.clicking = true
      this.methodUpdateNodeNav(node)
      this.parentTpId = node.deptTpId
      this.parentDeptId = node.deptId
      await this.addressGetNodes()
      this.clicking = false
    },
    // 切换部门勾选状态
    async handlerChangeDeptSelected(node) {
      if (!this.computedCanSelectDept) {
        return
      }
      if (node.selected) {
        this.addressBatchUnselectDept([node])
      } else {
        this.addressBatchSelectDept([node])
      }
    },
    // 切换人员节点勾选状态
    async handlerChangeMemberSelections(node) {
      if (!this.computedCanSelectMember) {
        return
      }
      // 非全选
      if (!this.multiple) {
        this.singleNodeSelected =
          (this.singleNodeSelected || {}).userTpId === node.userTpId
            ? {}
            : { ...node }
        return
      }
      if (node.selected) {
        this.addressBatchUnselectMember([node])
      } else {
        this.addressBatchSelectMember([node])
      }
    },
    // 全选操作
    async handlerToChangeSelections() {
      if (this.computedIsDisabledSelectAll) {
        return
      }
      // 全选时
      if (this.compuedIsSelectedAll) {
        await this.addressBatchUnselectDept(this.currentDepts)
        await this.addressBatchUnselectMember(this.currentMembers)
      } else {
        // 非全选时--以下全为当前级别下
        let curAllNum = this.currentMembers.length // 所有人员 人员+部门下所有人员

        const unSelectDepts = this.currentDepts.filter(node => {
          curAllNum += node.studentCnt
          return !node.selected
        })
        const unSelectMembers = this.currentMembers.filter(node => {
          return !node.selected
        })

        await this.addressBatchSelectDept(unSelectDepts)
        await this.addressBatchSelectMember(unSelectMembers)
      }
    },
    // 查看已选人员
    async handlerViewDetail() {
      if (!this.computedShowDetail) {
        return
      }
      this.selectedMembers = []
      this.getSelectedUsers()
      this.showSelectDetail = true
    },
    // 删除已选人员
    async clearMember(node) {
      await this.addressBatchUnselectMember([node])
      this.$nextTick(() => {
        this.searchMembers.map(v => {
          if (v.userId === node.userId) {
            v.selected = false
          }
        })
      })
    },
    // 删除已选部门
    async clearDept(node) {
      this.addressBatchUnselectDept([node])
    },
    // 查看已选-确认
    async confirmDetail() {
      await this.getSandboxStatus()
      await this.addressGetNodes()
      this.showSelectDetail = false
    },
    // 查看已选-清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选成员`,
        async onConfirm() {
          await that.addressUnslectAll()
          that.showSelectDetail = false
          that.currentMembers = []
          that.initData()
          that.init()
        }
      }).show()
    },
    // 初始化导航栏
    methodInitNodeNav({ name, deptId = '' } = {}) {
      this.nodeNav = [
        {
          deptName: name || getTitle(),
          deptId: deptId,
          type: 0
        }
      ]
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push(node)
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      this.methodUpdateNodeNav(node, false)
      this.parentTpId = node.deptTpId
      this.parentDeptId = node.deptId
      this.addressGetNodes()
    },
    // 点击确认 关闭选人组件
    async handlerToSubmit() {
      if (this.clicking) {
        return
      }
      this.clicking = true
      if (
        this.multiple
          ? this.forceSelection && !this.memberCount
          : !(this.singleNodeSelected || {}).userTpId
      ) {
        mcToast({ msg: '请选择人员' })
        this.clicking = false
        return
      }
      // 仅多选需要使用接口
      if (this.multiple) {
        await this.getSelectedUsers()
        if (this.memberCount > this.maxMember) {
          this.clicking = false
          mcToast({ msg: '人员超限' })
          return
        }
        await this.addressCommitPreSelections()
      }
      let _result = null
      // 0: 人员 1: 部门 2: 人员tpId 3: 部门tpId 4: 人员memberId 5: 部门memberId 6: 全选
      switch (+this.returnType) {
        case 0:
          _result = this.multiple
            ? this.selectedMembers || []
            : [this.singleNodeSelected]
          break
        case 1:
          _result = this.selectedDepts || []
          break
        case 2:
          _result = this.selectedTpIds || []
          break
        case 3:
          _result = this.selectedDeptTpIds || []
          break
        case 4:
          _result = this.selectedMemberIds || []
          break
        case 5:
          _result = this.selectedDeptIds || []
          break
        case 6:
          _result = {
            deptIds: this.selectedDeptIds || [],
            tpIds: this.selectedTpIds || [],
            depts: this.selectedDepts || [],
            members: this.selectedMembers || []
          }
          break
        default:
          _result = this.selectedTpIds || []
      }
      this.close(_result)
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcSetTitle(this.title)
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(async btnIndex => {
            if (btnIndex === 1) {
              mcHidePreloader()
              await this.addressRollbackPreSelections()
              this.closeOnly()
              mcSetTitle(this.pageTitle)
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 创建选人组件沙盒API
    addressCreate() {
      return new Promise((resolve, reject) => {
        API.createOrgSandBox({
          ...this.postData,
          calDeptAllMemberCnt: true
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            if (res) {
              store.commit('orgSandboxId', res)
              this.sandboxId = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    // 轮训查状态API
    getSandboxStatus() {
      // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 提交失败，待重试 8 已坏掉
      this.sandboxStatus = 1
      let _itvlTimes = 0
      mcShowPreloader()
      clearInterval(this.sandboxItvl)
      return new Promise((resolve, reject) => {
        if (this.isSandboxComplete) {
          resolve(true)
        } else {
          this.sandboxItvl = setInterval(async () => {
            ++_itvlTimes
            if (_itvlTimes >= 20) {
              clearInterval(this.sandboxItvl)
              this.addressResetStatus()
              mcHidePreloader()
              mcToast({ msg: '操作超时，请重试～' })
            }
            switch (this.sandboxStatus) {
              case 2:
                this.isSandboxComplete = true
                clearInterval(this.sandboxItvl)
                resolve(this.sandboxStatus)
                break
              case 8:
                clearInterval(this.sandboxItvl)
                this.addressResetStatus()
                mcHidePreloader()
                mcToast({ msg: '操作超时，请重试～' })
                this.initData()
                this.init()
              default:
                await this.addressGetStatus()
                break
            }
          }, 1000)
        }
      })
    },
    // 查询树准备情况API
    addressGetStatus() {
      return new Promise((resolve, reject) => {
        API.getOrgSandBoxStatus({
          ...this.postData,
          calcMemberSelCnt: true,
          sandboxId: this.sandboxId
        })
          .then(res => {
            this.sandboxStatus = res.sandboxStatus || 0
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },

    // 查树节点信息API
    addressGetNodes(init) {
      return new Promise(async (resolve, reject) => {
        this.currentDepts = []
        this.currentMembers = []
        this.fetchHandler('getOrgSubNodes', {
          parentDeptId: this.parentDeptId || null
        })
          .then(res => {
            // type 校区: 0 学段: 1 年级: 2 班级: 3 部门: 4
            this.currentDepts = (res || []).map(item => ({
              ...item,
              selected: false
            }))
            init &&
              (this.rootDeptId = (this.currentDepts[0] || {}).deptId || '')
            this.currentDepts.forEach(item => {
              item.selected = [1, 3].includes(item.selectStatus)
            })

            mcHidePreloader()
            resolve(res)
          })
          .catch(err => {
            mcHidePreloader()
            console.log(err)
          })
        if (this.parentDeptId) {
          const res = await this.fetchHandler('getOrgDeptUsers', {
            deptId: this.parentDeptId
          })
          this.currentMembers = res || []
          this.currentMembers.forEach(item => {
            item.selected = [1, 3].includes(item.selectStatus)
          })
        }
      })
    },
    selectNodes(nodes, init) {
      nodes.forEach(node => {
        node.selectStatus = init ? 1 : 3
        node.selected = true
        this.$set(node, 'selected', true)
        this.$set(node, 'selectStatus', init ? 1 : 3)
      })
    },
    unselectNodes(nodes) {
      nodes.forEach(node => {
        node.selectStatus = 4
        node.selected = false
        this.$set(node, 'selected', false)
        this.$set(node, 'selectStatus', 4)
      })
    },
    // 移除节点
    removeNodes(index, nodes = []) {
      nodes.forEach(item => {
        item.splice(index, 1)
      })
    },
    // 部门已选择人员
    async getSelectedUsers({ deptId = this.rootDeptId, all = true } = {}) {
      return new Promise(async resolve => {
        this.selectedMembers = []
        const res = await this.fetchHandler('getOrgSelectedUsers', {
          pageNumber: 1,
          pageSize: this.pageSize,
          deptId
        })
        if (all || !this.multiple) {
          this.selectedMembers = res.orgUserSandboxUserInfoResps || []
          this.selectedTpIds = this.selectedMembers.map(item => item.userTpId)
          this.selectedMemberIds = this.selectedMembers.map(item => item.userId)
          this.memberCount = res.total || 0
        }
        resolve(res.total || 0)
      })
    },
    // 批量选中部门
    async addressBatchSelectDept(nodes) {
      if (!nodes.length) {
        return
      }
      if (this.multiple) {
        let _count = 0
        let deptIds = []
        nodes.forEach(node => {
          // todo all-select
          _count += node.studentCnt
          deptIds.push(node.deptId)
        })
        this.fetchHandler('selectOrgDepts', {
          deptIds
        })
          .then(async res => {
            this.selectNodes(nodes)
            nodes.forEach(node => {
              this.selectedDeptIds.push(node.deptId)
              this.selectedDeptTpIds.push(node.deptTpId)
              this.selectedDepts.push(node)
            })
            await this.getSelectedUsers()
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        const node = nodes[0]
        if ((this.selectedDepts[0] || {}).deptTpId) {
          if (this.selectedDepts[0].deptTpId === node.deptTpId) {
            return
          }
          await this.addressBatchUnselectDept(nodes)
        }
        this.fetchHandler('selectOrgDepts', {
          deptIds: [node.deptId]
        })
          .then(async res => {
            this.selectNodes([node])
            this.selectedDeptIds = [node.deptId]
            this.selectedDeptTpIds = [node.deptTpId]
            this.selectedDepts = [node]
            await this.getSelectedUsers()
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 批量取消部门 API
    async addressBatchUnselectDept(nodes) {
      if (!nodes.length) {
        return
      }
      let deptIds = []
      nodes.forEach(node => {
        deptIds.push(node.deptId)
      })
      this.fetchHandler('unSelectOrgDepts', {
        deptIds
      })
        .then(async res => {
          this.unselectNodes(nodes)
          nodes.forEach(node => {
            const _index = this.selectedDepts.findIndex(item => {
              return item.deptId === node.deptId
            })
            this.removeNodes(_index, [
              this.selectedDepts,
              this.selectedDeptIds,
              this.selectedDeptTpIds
            ])
          })
          await this.getSelectedUsers()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 批量选中人员 API idSelect:初始化
    async addressBatchSelectMember(nodes, init) {
      if (!nodes.length) {
        return
      }
      let userIds = deepCopy(nodes)
      if (!init) {
        userIds = nodes.map(item => item.userId)
      }
      if (this.multiple) {
        this.fetchHandler('selectOrgUsers', {
          userIds
        })
          .then(async res => {
            if (!init) {
              this.selectNodes(nodes, init)
              nodes.forEach(node => {
                this.selectedMemberIds.push(node.userId)
                this.selectedTpIds.push(node.userTpId)
                this.selectedMembers.push(node)
              })
            }
            await this.getSelectedUsers()
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        const node = nodes[0]
        // 单选
        if ((this.selectedMembers[0] || {}).userTpId) {
          if (this.selectedMembers[0].userTpId === node.userTpId) {
            return
          }
          await this.addressBatchUnselectMember(this.selectedMembers)
        }
        this.fetchHandler('selectOrgUsers', {
          userIds
        })
          .then(async res => {
            this.currentMembers.forEach(item => {
              item.selected = false
            })
            this.selectNodes(nodes)
            this.selectedMemberIds = [node.userId]
            this.selectedTpIds = [node.userTpId]
            this.selectedMembers = [node]
            await this.getSelectedUsers()
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 批量取消人员 API
    async addressBatchUnselectMember(nodes) {
      if (!nodes.length) {
        return
      }
      const userIds = nodes.map(node => node.userId)
      const res = await this.fetchHandler('unSelectOrgUsers', {
        userIds
      })
      this.unselectNodes(nodes)
      nodes.forEach(node => {
        const _index = this.selectedMembers.findIndex(item => {
          return item.userId === node.userId
        })
        this.removeNodes(_index, [
          this.selectedMembers,
          this.selectedMemberIds,
          this.selectedTpIds
        ])
      })
      await this.getSelectedUsers()
    },
    // 清除所有已选择API
    async addressUnslectAll() {
      await this.fetchHandler('unSelectOrgAll')
      this.selectedMembers = []
      this.selectedTpIds = []
      this.selectedMemberIds = []
      this.memberCount = 0
    },
    // 搜索人员API
    fetchMembersByKey() {
      return new Promise((resolve, reject) => {
        let API_URL = 'searchOrgUsers'
        let requestData = { limit: 50, q: this.searchKey }
        if (this.returnType === 1) {
          API_URL = 'searchOrgDepts'
          requestData = {
            keyWord: this.searchKey
          }
        }
        this.fetchHandler(API_URL, requestData)
          .then(res => {
            this.searchMembers = res || []
            this.searchMembers.forEach(item => {
              item.selected = [1, 3].includes(item.selectStatus)
            })
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    // 提交预选项API
    addressCommitPreSelections() {
      this.fetchHandler('commitOrgSandBox')
    },
    // 取消预选项
    async addressRollbackPreSelections() {
      await this.fetchHandler('rollbackOrgSandox')
    },
    // 重置沙箱
    async addressResetStatus() {
      await this.fetchHandler('resetOrgSandBox')
    },
    // 销毁沙箱
    async addressRollback() {
      await this.fetchHandler('rollbackOrgSandBox')
    },
    // 通用api
    fetchHandler(apiUrl, param = {}) {
      return new Promise((resolve, reject) => {
        API[apiUrl]({ ...this.postData, sandboxId: this.sandboxId, ...param })
          .then(res => {
            mcHidePreloader()
            if (res && res.result && res.result !== '0') {
              mcToast({ msg: res.message })
              return false
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.head-img-text {
  height: 36px;
  width: 36px;
  color: #ffffff;
  margin-right: 12px;
  background: #006afe;
  border-radius: 50%;
}
.footer {
  :deep(.c-button) {
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
  }
}
</style>
